import { Desktop, Mobile } from "@/lib/common/MediaQueries"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useEffect, useState } from "react"

const StyledTimer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  height: 35px;
  margin-top: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 24px;
    justify-content: flex-end;
  }
`

const StyledItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 8px;
  }
`

const StyledItemText = styled(Typography)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 39px;
    padding-top: 13px;
  }
`

const StyledNumber = styled.span`
  display: block;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 40px;
  }
`

export default function BannerCounter({ dueDate }: { dueDate: string }): React.ReactElement {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  const timeUnitText = {
    desktop: {
      day: "ימים",
      hour: "שעות",
      minutes: "דקות",
      seconds: "שניות",
    },
    mobile: {
      day: "ימ׳",
      hour: "שע׳",
      minutes: "דק׳",
      seconds: "שנ׳",
    },
  }

  useEffect(() => {
    const calculateTimeLeft = (): void => {
      const finalDate = new Date(dueDate)
      const now = new Date()
      const difference = finalDate.getTime() - now.getTime()

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        })
      }
    }

    const timer = setInterval(calculateTimeLeft, 1000)
    calculateTimeLeft()

    return () => clearInterval(timer)
  }, [dueDate])

  return (
    <StyledTimer>
      <StyledItem>
        <StyledNumber>{timeLeft.days}</StyledNumber>
        <Desktop>
          <StyledItemText>{timeUnitText?.desktop?.day}</StyledItemText>
        </Desktop>
        <Mobile>
          <StyledItemText>{timeUnitText?.mobile?.day}</StyledItemText>
        </Mobile>
      </StyledItem>
      <StyledItem>
        <StyledNumber>{timeLeft.hours}</StyledNumber>
        <Desktop>
          <StyledItemText>{timeUnitText?.desktop?.hour}</StyledItemText>
        </Desktop>
        <Mobile>
          <StyledItemText>{timeUnitText?.mobile?.hour}</StyledItemText>
        </Mobile>
      </StyledItem>
      <StyledItem>
        <StyledNumber>{timeLeft.minutes}</StyledNumber>
        <Desktop>
          <StyledItemText>{timeUnitText?.desktop?.minutes}</StyledItemText>
        </Desktop>
        <Mobile>
          <StyledItemText>{timeUnitText?.mobile?.minutes}</StyledItemText>
        </Mobile>
      </StyledItem>
      <StyledItem>
        <StyledNumber>{timeLeft.seconds}</StyledNumber>
        <Desktop>
          <StyledItemText>{timeUnitText?.desktop?.seconds}</StyledItemText>
        </Desktop>
        <Mobile>
          <StyledItemText>{timeUnitText?.mobile?.seconds}</StyledItemText>
        </Mobile>
      </StyledItem>
    </StyledTimer>
  )
}
